<template>
    <div class="visa-master-card">
        
        <!-- 头部导航 -->
        <m-header title="Credit Card Payment"> </m-header>

        <div class="visa-input m-top-30">
            <span class="input-title">Card Holder Name</span>
            <input type="text" v-model="card_name" class="input">
        </div>
        <div class="visa-input m-top-42">
            <span class="input-title">Card Number</span>
            <input type="text" v-model="card_number" @input="onCard($event)" @paste="onPaste($event)"  :maxlength="22" class="input">
        </div>

        <van-row gutter="20"  class="m-top-42">
            <van-col span="12">
                <div class="visa-input">
                    <span class="input-title">Valid Thru</span>
                    <input type="text"  v-model="card_date" @keyup="onDate($event)" :maxlength="5"  class="input" placeholder="MM/YY">
                </div>
            </van-col>
            <van-col span="12">
                <div class="visa-input">
                    <span class="input-title">CVV2</span>
                    <input type="number" v-model="card_cvd" @input="onCvd($event)" class="input" placeholder="CVC">
                </div>
            </van-col>
        </van-row>
        <div class="visa-input m-top-42">
            <span class="input-title">Postal Code</span>
            <input type="text" v-model="card_postal_code" maxlength="7" class="input" >
        </div>
         <div class="continue" @click="onDone()">
            <van-button :loading="load" loading-text="paying..."  type="primary" block round color="linear-gradient(315deg, #F03C18 0%, #F06448 100%)">
                <img class="btn-icon" src="data:image/png;base64,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" alt="">
                Confirm
            </van-button>
        </div>

    </div>
</template>



<script>
import MHeader  from '@/components/zh/m-header.vue'
import { visa_pay } from '@/api/zh/cart.js'
export default {
    name: 'VisaMaster',
    components:{ MHeader },
    data() {
        return {
            card_name: '',
            card_number: '',
            card_date: '',
            card_cvd: '',
            card_postal_code: '',

            load: false,
        }
    },
    methods: {


        // 卡号事件 
       onCard(e) {
           if(e.data) {
               if(e.target.value.length > 4 && this.card_number[4] != ' ') {
                    this.card_number  = e.target.value.slice(0,4) + ' ' + e.target.value.slice(4)
                }
                if(e.target.value.length > 9 && e.target.value[9] != ' ') {
                   this.card_number  = e.target.value.slice(0,9) + ' ' + e.target.value.slice(9)
                }
                if(e.target.value.length > 14 && e.target.value[14] != ' ') {
                    this.card_number  = e.target.value.slice(0,14) + ' ' + e.target.value.slice(14)
                }
           }else{
               if(e.target.value.length == 5) {
                    this.card_number  = e.target.value.slice(0,4) 
                }
                if(e.target.value.length == 10) {
                   this.card_number  = e.target.value.slice(0,9) 
                }
                if(e.target.value.length == 15) {
                    this.card_number  = e.target.value.slice(0,14)
                }
           }
           
       },
        // 卡号粘贴事件
       onPaste(e) {
           this.card_number = e.clipboardData.getData('Text')
           if(this.card_number.length > 4 && this.card_number[4] != ' ') {
                this.card_number  = this.card_number.slice(0,4) + ' ' + this.card_number.slice(4)
            }
            if(this.card_number.length > 9 && this.card_number[9] != ' ') {
                this.card_number  = this.card_number.slice(0,9) + ' ' + this.card_number.slice(9)
            }
            if(this.card_number.length > 14 && this.card_number[14] != ' ') {
                this.card_number  = this.card_number.slice(0,14) + ' ' + this.card_number.slice(14)
            }
            let number = this.card_number
            setTimeout( () => {
                this.card_number = number
            })
       },
        

       // 有效期事件
       onDate(e) {
           let date = e.target.value
           if(date.length >2 && e.keyCode != 8 && date[2] != '/') {
               this.card_date = date.slice(0, 2) + '/' + date.slice(2)
           }
           if(this.card_date.length > 5) {
               this.card_date = this.card_date.slice(0, 5)
           }
           
       },

        // 安全码改变事件 
        onCvd(e) {
            if(e.target.value.length >= 4) {
                e.target.value = e.target.value.slice(0, 4)
                this.card_cvd  = e.target.value
            }
        },

         // 邮编事件
        onCode(e) {
            if(e.keyCode != 8) {
                if(e.target.value.length > 3 && e.target.value[3] != ' ') {
                    this.card_postal_code  = e.target.value.slice(0,3) + ' ' + e.target.value.slice(3)
                }
            }else {
                if(e.target.value.length == 4) {
                    this.card_postal_code  = e.target.value.slice(0,3) 
                }
            }
            this.card_postal_code = this.card_postal_code.toUpperCase()
        },
        // 邮编粘贴事件
        codePaste(e) {
            this.card_postal_code = e.clipboardData.getData('Text')
            if(this.card_postal_code.length > 3 && this.card_number[3] != ' ') {
                this.card_postal_code  = this.card_postal_code.slice(0,3) + ' ' + this.card_postal_code.slice(3, 6)
            }
        },


        // 确认支付
        onDone() {
           // 判断是否是小程序支付
            if(this.$store.state.isMiniProgram) {
                let lang = localStorage.getItem('lang')
                let token = localStorage.getItem('token')
                window.wx.miniProgram.navigateTo({url: `/pages/pay/pay?title=${this.$route.params.title}&lang=${lang}&token=${token}`})
                return false
            }
            let params = {
                order_title: this.$route.params.title
            }


            if(this.card_name == '') {
                this.$notify({ type: 'warning', message: 'Please enter card holder name' })
                return false
            }else {
                params.card_name = this.card_name
            }

            if(this.card_number == '') {
                this.$notify({ type: 'warning', message: 'Please enter card number' })
                return false
            }else {
                params.card_number = this.card_number.replace(/\s*/g,"")
            }

            if(this.card_date.length != 5) {
                this.$notify({ type: 'warning', message: 'Please enter valid thru' })
                return false
            }else {
                params.card_expiry_month = this.card_date.split('/')[0]
                params.card_expiry_year  = this.card_date.split('/')[1]
            }

            if(this.card_cvd == '') {
                this.$notify({ type: 'warning', message: 'Please enter CVC2' })
                return false
            }else {
                params.card_cvd = this.card_cvd
            }

            // eslint-disable-next-line
            // let reg = /^([a-zA-Z][0-9]){3}$/
            // if(!reg.test(this.card_postal_code.replace(/\s*/g,""))) {
            //     this.$notify({ type: 'warning', message: 'Zip code error' });
            //     return false
            // }else {
            //     params.card_postal_code = this.card_postal_code.replace(/\s*/g,"")
            // }
            if(this.card_postal_code == '') {
                this.$notify({ type: 'warning', message: 'Zip code error' })
                return false
            }else {
                params.card_postal_code = this.card_postal_code
            }
            this.load = true
            visa_pay(params).then(res => {
                if(res) {
                    this.$router.replace( {path: '/en/paystatus', query: { t: this.$route.params.title, status: 1 } } )
                }else{
                    this.$router.replace( {path: '/en/paystatus', query: { t: this.$route.params.title, status: 2 } } )
                }
            }).finally( () => {
                this.load = false
            })
        }
        
    },
    create() {
        
    },


}
</script>

<style lang="less" scoped>
.visa-master-card{
    width: 100%;
    height: 100%;
    padding: 44px 16px 0;
    background: #fff;
    .visa-input {
        width: 100%;
        height: 50px;
        border-radius: 3px;
        border: 2px solid #3284FA;
        box-sizing: border-box;
        position: relative;
        .input-title {
            background: #fff;
            padding: 0 5px;
            height: 18px;
            line-height: 18px;
            color: #333333;
            letter-spacing: 0.5px;
            font-weight: 400;
            font-size: 16px;
            position: absolute;
            top: -12px;
            left: 8px;
        }

        .input {
            width: 100%;
            height: 40px;
            position: relative;
            top: 6px;
            font-size: 16px;
            border: none;
            outline: none;
            appearance: none;
            padding-left: 12px;
            &::placeholder {
                font-size: 16px;
                font-weight: 400;
                line-height: 16px;
                color: #999;
            }
        }
    }
    .m-top-30 {
        margin-top: 30px;
    }
    .m-top-42 {
        margin-top: 42px;
    }
    .continue{
        width: 300px;
        margin:60px auto 0;
        font-size: 16px;
        /deep/ .van-loading {
            margin: 0;
        }
        .btn-icon {
            width: 16px;
            height: 20px;
            object-fit: contain;
            margin-right: 8px;
            vertical-align: -5px;
        }
    }

    

}
</style>